import { useCallback, useEffect, useRef } from 'react'
import { useMount } from './useMount'

// See https://github.com/zoom/videosdk-web-sample/blob/v2.1.10/src/feature/chat/hooks/useParticipantsChange.ts
export function useParticipantsChange(client: any, fn: (participants: any[]) => void) {
  const fnRef = useRef(fn)
  fnRef.current = fn
  const callback = useCallback(() => {
    const participants = client.getAllUser()
    fnRef.current?.(participants)
  }, [client])
  useEffect(() => {
    client.on('user-added', callback)
    client.on('user-removed', callback)
    client.on('user-updated', callback)
    client.on('peer-video-state-change', callback)
    client.on('video-capturing-change', callback)
    client.on('video-active-change', callback)
    client.on('media-sdk-change', callback)
    return () => {
      client.off('user-added', callback)
      client.off('user-removed', callback)
      client.off('user-updated', callback)
      client.off('peer-video-state-change', callback)
      client.off('video-capturing-change', callback)
      client.off('video-active-change', callback)
      client.off('media-sdk-change', callback)
    }
  }, [client, callback])
  useMount(() => {
    callback()
  })
}
